/**
 * GapMindset MDXEditor Plugin
 *
 * Renders a mindset image block fetched by mindset ID.
 *
 * MARKDOWN SYNTAX (leafDirective - block-level):
 * ::GapMindset{id="mindset-id" orgId="00gap"}
 */
import { DirectiveDescriptor } from "@mdxeditor/editor"
import GapMindsetComponent from "./GapMindsetComponent"

export const MINDSET_DIRECTIVE_NAME = 'GapMindset'

export const GapMindsetDirectiveDescriptor: DirectiveDescriptor = {
   name: MINDSET_DIRECTIVE_NAME,
   type: 'leafDirective',
   testNode(node) {
      return node.name === MINDSET_DIRECTIVE_NAME
   },
   attributes: ['id', 'orgId', 'width', 'height'],
   hasChildren: false,
   Editor: GapMindsetComponent,
}
